module.exports = __webpack_public_path__ + "img/sassuolo-logo-icon.252c3708.png";